module.exports = __webpack_public_path__ + "static/media/layers-2x.8f2c4d11.png";